'use client';

import { Typography } from 'lighthouse';

import { AttributeFilterTitleProps } from './models';

export const AttributeFilterTitle = ({ name, icon: Icon }: AttributeFilterTitleProps) => (
    <span className='flex items-center gap-2'>
        {Icon ? <Icon size={18} color='currentColor' variant='Bold' className='shrink-0 text-primary' /> : null}
        <Typography variant='subtitle1' component='span' color='blackHighEmphasis' className='font-semibold'>
            {name}
        </Typography>
    </span>
);
